import React from 'react';

import Card from '../components/Card';
import CardContent from '../components/Card/CardContent';
import Heading from '../components/Heading';
import HeadingContext from '../components/Heading/HeadingContext';
import { ModalProps } from '../components/Modal/ModalContextProvider';
import VisitForm from '../forms/VisitForm';
import { AddressResource } from '../models';

const AddressModal = ({ address, handleClose }: ModalProps<{ address: AddressResource }>) => {
  return (
    <Card>
      <HeadingContext>
        <CardContent endSpacing>
          <Heading>{address.attributes.fullAddress}</Heading>
          <VisitForm address={address} onClose={handleClose} />
        </CardContent>
      </HeadingContext>
    </Card>
  );
};

export default AddressModal;
